<template>
  <div class="all-ideas">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <ContentHeader name="All abuse reports"></ContentHeader>
        <div class="alert alert-info">
          <button type="button" class="btn btn-primary float-right" v-b-toggle.filterControls v-on:click="showHideFilters()">
            <span v-html="showHideFilterText"></span>
          </button>
          <h4 class="alert-heading">Filtered Search</h4>
          <b-collapse visible id="filterControls" accordion="link-accordion" role="tabpanel">
            <hr>
            <div class="row">
              <div class="col-sm-6 mb-2">
                <label for="nominatorFilter">Reporter</label>
                <div class="input-group">
                  <input type="text" id="nominatorFilter" v-model="reporterFilter" v-on:keyup.enter="filterByReporter()" class="form-control" placeholder="Enter name...">
                  <div class="input-group-append">
                    <button v-on:click="filterByReporter()" type="submit" id="searchsubmit" class="btn btn-primary">{{reporterFilterButton}}</button>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 mb-2">
                <label for="reporterFilter">Reported person</label>
                <div class="input-group">
                  <input id="reporterFilter" type="text" v-model="reporteeFilter" v-on:keyup.enter="filterByReportee()" class="form-control" placeholder="Enter name...">
                  <div class="input-group-append">
                    <button v-on:click="filterByReportee()" type="submit" id="searchsubmit" class="btn btn-primary">{{reporteeFilterButton}}</button>
                  </div>
                </div>
              </div>
            </div>
          </b-collapse>
        </div>
        <table class="table">
          <thead>
            <tr>
              <th scope="col" class="text-black-50 border-top-0">Reporter</th>
              <th scope="col" class="text-black-50 border-top-0">Abuse report</th>
              <th scope="col" class="text-black-50 border-top-0">Reported person</th>
            </tr>
          </thead>
          <tbody>
            <AbuseReportTableRow
              v-for="abuse in abuseReports"
              v-bind:key="abuse.id"
              :author="abuse._embedded.author[0].name"
              :report="abuse.content.rendered"
              :ideaID="abuse.idea_post_id_report_abuse[0]"
              :reportee="abuse.abuse_reported_person[0]">
            </AbuseReportTableRow>
          </tbody>
          <tfoot>
            <tr>
              <th scope="col" class="text-black-50 border-top-0">Reporter</th>
              <th scope="col" class="text-black-50 border-top-0">Abuse report</th>
              <th scope="col" class="text-black-50 border-top-0">Reported person</th>
            </tr>
          </tfoot>
        </table>
        <span v-if="abuseReports.length === 0">
          No ideas have been reported for abuse
        </span>
        <div class="row">
          <div class="col-sm-6 mt-3">
            <b-pagination size="md" :total-rows="totalPosts" v-model="currentPage" :per-page="itemsPerPage"></b-pagination>
          </div>
          <div class="col-sm-6 mt-3">
            <div class="items-per-page">
              <label for="itemsPerPage">Items per page: </label>
              <select v-model="itemsPerPage" id="itemsPerPage" v-on:change="loadPosts()" class="form-control">
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import ContentHeader from '@/components/ContentHeader'
import AbuseReportTableRow from '@/components/AbuseReportTableRow'
import PreContentHeader from '@/components/PreContentHeader'
export default {
  components: {
    PreContentHeader,
    ContentHeader,
    AbuseReportTableRow
  },
  data () {
    return {
      abuseReports: [],
      abuseReportsOG: [],
      contentReady: false,
      contentLoadError: '',
      reporterFilter: '',
      reporteeFilter: '',
      reporterFilterButton: '+',
      reporteeFilterButton: '+',
      showHideFilterText: '<i class="fas fa-angle-up"></i>',
      currentPage: 1,
      totalPosts: 0,
      itemsPerPage: 10
    }
  },
  created () {
    document.title = this.$route.name + ' - ThinkTank'
    this.loadPosts()
  },
  methods: {
    loadPosts: function () {
      WordpressRestAPI.getViewContent('abuse_report?_embed&page=' + this.currentPage + '&per_page=' + this.itemsPerPage)
        .then(response => {
          this.totalPosts = parseInt(response.headers['x-wp-total'])
          this.abuseReports = response.data
          this.abuseReportsOG = response.data
          this.contentReady = true
        })
        .catch(e => {
          console.error(e)
        })
    },
    showHideFilters: function () {
      if (this.showHideFilterText === '<i class="fas fa-angle-up"></i>') {
        this.showHideFilterText = '<i class="fas fa-angle-down"></i>'
      } else {
        this.showHideFilterText = '<i class="fas fa-angle-up"></i>'
      }
    },
    filterByReporter: function () {
      this.abuseReports = this.abuseReportsOG
      var self = this
      if (this.reporterFilter !== '' && this.reporterFilterButton === '+') {
        this.abuseReports = this.abuseReports.filter(x => x._embedded.author[0].name.toLowerCase().indexOf(self.reporterFilter.toLowerCase()) > -1)
      }
      if (this.reporterFilterButton === '+') {
        this.reporterFilterButton = 'x'
      } else {
        this.reporterFilterButton = '+'
        this.reporterFilter = ''
      }
    },
    filterByReportee: function () {
      this.abuseReports = this.abuseReportsOG
      var self = this
      if (this.reporteeFilter !== '' && this.reporteeFilterButton === '+') {
        this.abuseReports = this.abuseReports.filter(x => x.abuse_reported_person[0].toLowerCase().indexOf(self.reporteeFilter.toLowerCase()) > -1)
      }
      if (this.reporteeFilterButton === '+') {
        this.reporteeFilterButton = 'x'
      } else {
        this.reporteeFilterButton = '+'
        this.reporteeFilter = ''
      }
    }
  },
  watch: {
    'currentPage' (newDetails, oldDetails) {
      this.loadPosts()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/routes/ReportAbuseReports.vue